import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { PageHeaderInlineEdit, FauxPageHeaderInlineEdit } from 'ui/inlineEdit';
import { addNegativeToast } from 'modules/toastContainer';

import { useListDetailsContext } from '../../contexts/listDetails';
import { usePermissionsContext } from '../../contexts/permissions';
import { useListId, useTranslation, useUpdateListNameMutation } from '../../hooks';

export const ListName = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { canManageSegmentation } = usePermissionsContext();
  const listId = useListId();
  const { list, isLoading } = useListDetailsContext();
  const { updateListName } = useUpdateListNameMutation(listId);
  const [listName, setListName] = useState(list.name);

  const handleBlur = () => {
    if (!listName.trim()) {
      dispatch(addNegativeToast(t('toast.listName.required')));
      // reset state to original saved list name
      setListName(list.name);
    } else if (listName !== list.name) {
      updateListName(listName.trim());
    }
  };

  useEffect(() => {
    if (!isLoading) {
      setListName(list.name);
    }
  }, [isLoading, list]);

  return canManageSegmentation ? (
    <PageHeaderInlineEdit
      maxLength={255}
      onBlur={handleBlur}
      onChange={setListName}
      showTooltipWhenOverflow
      value={listName}
    />
  ) : (
    <FauxPageHeaderInlineEdit showTooltipWhenOverflow value={listName} />
  );
};
